
  import { SendLicenseEmailCommand, LicenseMailTemplate } from '@/apiclient/apiclient_generated';
  import { NotificationService } from '@/services/notification-service';
  import { AccountModule, AccountStore } from '@/store/account';
  import { LicenseModule, LicenseStore } from '@/store/license';
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class SendLicenseEmail extends Vue {
    private accountStore: AccountModule = AccountStore;
    private licenseStore: LicenseModule = LicenseStore;

    @Prop() account;
    @Prop() license;

    mailTemplates = [LicenseMailTemplate.TrialTemplate, LicenseMailTemplate.PurchaseTemplate];

    subject = 'presentaid - your free trial starts today!';
    mailTemplate = LicenseMailTemplate.TrialTemplate;
    isLoading = false;

    get modalHeader() {
      return 'License Email';
    }

    get firstName() {
      return this.account?.name;
    }

    get lastName() {
      return this.account?.surname;
    }

    get to() {
      return this.account?.email;
    }

    get isFormValid() {
      return this.subject && !this.isLoading;
    }

    async submitForm() {
      this.isLoading = true;

      const command = {
        email: this.account.email,
        firstName: this.account.name,
        lastName: this.account.surname,
        subject: this.subject,
        licenseKey: this.license.key,
        expirationDate: this.license.expiryDate,
        maxActivations: this.license.maximumActivations,
        licenseMailTemplate: this.mailTemplate
      } as SendLicenseEmailCommand;

      const result = await this.licenseStore.sendLicenseEmail(command);

      this.isLoading = false;

      if (result.isSuccess) {
        NotificationService.NotifySuccess('Your email was successfully sent.');

        this.$emit('close');
      } else {
        NotificationService.NotifyErrors(result.errors);
      }
    }

    cancelForm() {
      this.$emit('cancel');
    }
  }
